// Recuadro del ícono de una app, compartido por el menú de apps (AppsMenu), el
// riel de favoritas (AppsRail) y la cortina «Abriendo…».
//
// En reposo el recuadro es neutro y el ícono gris oscuro/claro; al pasar el
// cursor toma un tinte del verde de la marca. La app actual va invertida (casi
// negro en claro, casi blanco en oscuro): el verde lleno era lo más fuerte de
// la pantalla (Daniel, 30-oct). Así el color dice "dónde estoy / qué puedo
// tocar", no "qué app es": eso lo dice el ícono. Los `group-hover` asumen que
// el contenedor clickeable lleva `group`.
export type TileState = "idle" | "active" | "disabled";

export const appTileClass = (state: TileState, isDarkMode: boolean): string => {
  if (state === "active") return isDarkMode ? "bg-zinc-100 text-zinc-900" : "bg-zinc-900 text-white";
  if (state === "disabled")
    return isDarkMode ? "bg-white/[0.04] text-zinc-500" : "bg-zinc-100 text-zinc-400";
  return isDarkMode
    ? "bg-white/[0.07] text-zinc-200 group-hover:bg-primary-500/15 group-hover:text-primary-400"
    : "bg-zinc-200/70 text-zinc-700 group-hover:bg-primary-500/20 group-hover:text-zinc-900";
};
